export var $location = {
  href: '',
  protocol: '',
  host: ''
};
//# sourceMappingURL=location.js.map